<template>
  <div class="c-product-card-vertical">
    <div class="c-product-card-vertical__rank-badge">
      <f-product-card-rank-badge
        v-if="rankNumber"
        :rank-number="rankNumber"
      ></f-product-card-rank-badge>
    </div>

    <div class="c-product-card-vertical__status-label">
      <f-product-card-status-label
        :product-status="product.productStatus"
        position="left bottom"
        type="triangle-small"
      ></f-product-card-status-label>
    </div>

    <a
      class="c-product-card-vertical__link"
      :href="product.url"
      :aria-label="product.plainTitle"
      @click="onProductCardClick"
    >
      <div class="c-product-card-vertical__image">
        <img
          :src="product.imageUrl"
          :alt="product.plainTitle"
          width="72"
          height="72"
        />
      </div>

      <div class="c-product-card-vertical__content">
        <h3 class="c-product-card-vertical__title" v-html="title"></h3>
        <div class="c-product-card-vertical__review">
          <review-summary :product="product" />
        </div>

        <div class="c-product-card-vertical__row">
          <div class="c-product-card-vertical__row-item">
            <f-product-card-price-area :product="product" />
          </div>
          <div class="c-product-card-vertical__button-area">
            <f-product-card-button-area :product="product" />
          </div>
          <div class="c-product-card-vertical__row-item">
            <f-heart
              :id="product.id"
              :handle="product.handle"
              :is-favourite="isFavourite"
              @heart-changed="onHeartChanged"
            ></f-heart>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import Product from '~/js/models/product'
import OSProduct from '~/js/models/OSProduct'
import { pushProductClickEvent } from '~/js/gtm'

import FHeart from '~/js/components/heart'
import FProductCardButtonArea from '~/js/components/productCard/buttonArea'
import FProductCardPriceArea from '~/js/components/productCard/priceArea'
import FProductCardRankBadge from '~/js/components/productCard/rankBadge'
import FProductCardStatusLabel from '~/js/components/productCard/statusLabel'
import ReviewSummary from '~/js/components/reviewSummary/index.vue'

export default {
  name: 'ComponentsProductCardVertical',
  components: {
    FHeart,
    FProductCardButtonArea,
    FProductCardPriceArea,
    FProductCardRankBadge,
    FProductCardStatusLabel,
    ReviewSummary,
  },
  props: {
    product: {
      type: [Product, OSProduct],
      required: true,
      default: () => {
        return new Product()
      },
    },
    rankNumber: { type: [Number, null], default: null },
  },
  data() {
    return {
      isFavourite: false,
    }
  },
  computed: {
    title() {
      return this.product.enhancedTitle
    },
  },
  methods: {
    onProductCardClick() {
      pushProductClickEvent({
        product: this.product,
        position: this.rankNumber,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:color';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-card-vertical {
  background-color: #fff;
  border-radius: 8px;
  height: 100%;
  overflow: hidden;
  position: relative;

  &__rank-badge {
    left: 5px;
    position: absolute;
    top: 5px;
  }

  &__status-label {
    bottom: 0;
    left: 0;
    position: absolute;
    z-index: 1;
  }

  &__link {
    display: flex;
    gap: 10px;
    padding: 10px;

    &:hover {
      background-color: color.adjust(variables.$color-pink, $lightness: 4%);
    }
  }

  &__image {
    width: 72px;
    flex-shrink: 0;
  }

  &__content {
    flex-grow: 1;
  }

  &__title {
    display: -webkit-box;
    flex-grow: 1;
    font-size: 13px;
    font-weight: 600;
    height: auto;
    margin-top: 0;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  &__review {
    margin: 4px 0;
    min-height: 18px;
  }

  &__row {
    align-items: flex-end;
    display: flex;
    gap: 5px;
  }

  &__row-item,
  &__button-area {
    flex-shrink: 0;
  }

  &__button-area {
    flex-grow: 1;
  }
}
</style>
